var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SubmitHoursButton } from '../../../../ui/components/SubmitHoursButton';
import { useMissionsTranslation } from '../../../../ui/hooks';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import React from 'react';
export const AddHoursButton = ({ volunteerName, shiftStartTime, shiftStopTime, onAddHours, shiftId, participationId, participantShiftStartTime, participantShiftStopTime, missionOrganizationSharing, }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(SubmitHoursButton, { variant: 'text', "data-test": 'add-hours-button', dialogTitle: t('shifts.adminTimeTracking.addHoursDialog.title', { volunteerName }), dialogContent: t('shifts.adminTimeTracking.addHoursDialog.content', {
            date: t('date', { value: shiftStartTime }),
            startTime: t('time', { value: shiftStartTime }),
            endTime: t('time', { value: shiftStopTime }),
        }), submitLabel: t('shifts.adminTimeTracking.addHoursDialog.submitButtonText'), shiftStartTime: shiftStartTime, shiftStopTime: shiftStopTime, participantShiftStartTime: participantShiftStartTime, participantShiftStopTime: participantShiftStopTime, startIcon: React.createElement(AddOutlinedIcon, null), onSubmit: (data) => __awaiter(void 0, void 0, void 0, function* () {
            onAddHours({
                shiftId: shiftId,
                participationId: participationId,
                shiftStartTime: data.addHours.from,
                shiftStopTime: data.addHours.to,
                missionOrganizationSharing,
            });
        }) }, t('timeTracking.addHoursButtonText')));
};
